import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { FaTimes, FaCheckCircle } from 'react-icons/fa';

const PasswordStep = ({ setPassword, nextStep }) => {
  const [password1, setPassword1] = useState("");
  const [password2, setPassword2] = useState("");
  const [lengthRequirement, setLengthRequirement] = useState(false);
  const [digitRequirement, setDigitRequirement] = useState(false);

  const handlePassword1Change = (e) => {
    const value = e.target.value;
    setPassword1(value);
    setLengthRequirement(value.length >= 8);
    setDigitRequirement(/\d/.test(value));
  };

  const handlePassword2Change = (e) => {
    setPassword2(e.target.value);
  };

  const handleSetPassword = () => {
    const passwordRegex = /^(?=.*\d).{8,}$/;

    if (!passwordRegex.test(password1)) {
      toast.error("Password must be at least 8 characters long and contain a digit.");
      toast.error("Contraseña debe tener almenos 8 caracteres y un digito.");
    } else if (password1 !== password2) {
      toast.error("Passwords do not match");
    } else {
      setPassword(password1);
      nextStep();
    }
  };

  return (
    <div className="flex flex-col bg-bg p-4 rounded-xl border border-border shadow-sm w-full sm:w-1/3 mx-auto">
      <div className="mb-4">
        <label
          className="block text-label font-semibold text-ink mb-1"
          htmlFor="password"
        >
          New Password:
        </label>
        <input
          type="password"
          id="password"
          value={password1}
          onChange={handlePassword1Change}
          onPaste={(event) => event.preventDefault()}
          className="w-full rounded-md border border-border px-3 py-2 text-body text-ink placeholder:text-ink-4 focus:outline-none focus:ring-2 focus:ring-brand/40"
        />
      </div>

      <div className="flex flex-col items-start mb-4">
        <div className="flex items-center mb-2">
          {lengthRequirement ? (
            <FaCheckCircle className="text-active mr-2" />
          ) : (
            <FaTimes className="text-critical mr-2" />
          )}
          <p className="text-body text-ink-2">8 characters long</p>
        </div>
        <div className="flex items-center">
          {digitRequirement ? (
            <FaCheckCircle className="text-active mr-2" />
          ) : (
            <FaTimes className="text-critical mr-2" />
          )}
          <p className="text-body text-ink-2">Contain a digit</p>
        </div>
      </div>

      <div className="mb-4">
        <label
          className="block text-label font-semibold text-ink mb-1"
          htmlFor="confirm"
        >
          Confirm Password:
        </label>
        <input
          type="password"
          id="confirm"
          value={password2}
          onChange={handlePassword2Change}
          onPaste={(event) => event.preventDefault()}
          className="w-full rounded-md border border-border px-3 py-2 text-body text-ink placeholder:text-ink-4 focus:outline-none focus:ring-2 focus:ring-brand/40"
        />
      </div>

      <div className="text-center mt-4">
        <button
          onClick={handleSetPassword}
          className="bg-ink text-white px-4 py-2 rounded-lg text-label font-medium hover:bg-ink-2 transition"
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default PasswordStep;